import { css } from '@emotion/react';
import { InputTextColors } from './checkbox';
import { SetStateAction } from 'react';

interface RadioButtonProps {
  name: string;
  id: string;
  value: string;
  selected: string;
  label?: string;
  color?: InputTextColors;
  checked?: boolean;
  disabled?: boolean;
  onChangeHandler: React.Dispatch<SetStateAction<string>>;
  className?: string;
}

const textStyle = (color: InputTextColors) => css`
  color: ${color};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.125rem;
  padding-left: 24px;
`;

const buttonStyle = css`
  background: var(--neutral-light-n-0, #fff);
  border: 1px solid var(--n-400, #505f79);
  border-radius: 16px;
  box-sizing: border-box;
  flex-shrink: 0;
  height: 16px;
  left: 0;
  position: absolute;
  top: 0;
  width: 16px;
`;

const containerStyle = css`
  display: block;
  position: relative;
  input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  input:checked + span {
    background: #ffffff;
    border: 4px solid #0052cc;
  }

  input:hover + span,
  input:focus + span {
    background: #dfe1e6;
  }

  input:disabled + span {
    background: #f4f5f7;
    border: none;
  }

  input:disabled:checked + span {
    background: #a5adba;
    border: 4px solid #f4f5f7;
  }
`;

export const RadioButton = (props: RadioButtonProps) => {
  const {
    name,
    id,
    value,
    label,
    selected,
    disabled,
    onChangeHandler,
    className
  } = props;
  const textColor = disabled ? InputTextColors.Light : InputTextColors.Dark;

  return (
    <div className={className}>
      {label && (
        <label css={[textStyle(textColor), containerStyle]} htmlFor={id}>
          {label}
          <input
            type="radio"
            name={name}
            id={id}
            value={value}
            checked={selected === value}
            disabled={disabled}
            onChange={(e) => onChangeHandler(e.target.value)}
          ></input>
          <span css={buttonStyle}></span>
        </label>
      )}
    </div>
  );
};
